export const products = [
  'preamplifier077',
  'preamplifier088',
  'preamplifier035',
  'phonopreamplifier100',
  'preamplifier808mk5',
  'monopoweramplifier159',
  'poweramplifier909mk5',
  'poweramplifier218',
  'poweramplifier216',
  'poweramplifier911mk3',
  'poweramplifier956mk2',
  'poweramplifier036',
  'integratedamplifier032',
  'integratedamplifier082',
  'integratedamplifier101',
  'integratedamplifier232',
  'integratedamplifier232Phono',
  'integratedamplifier232Dac',
  'powerconditioner948',
  'recordplayer217',
  'recordplayer175',
  'cdplayer069',
  'cdplayer089',
  'cdPlayer061',
  'cdplayer102',
  'musiccenter111',
  'musiccenter151mk2',
  'allinone161',
  'phase3loftstyle',
  'phase3retrostyle',
  'inwallcoverframe',
  'inwallwoofer',
  'inwallcenter',
  'inwallsatellite',
  'loudspeakerb10',
  'floorstandingloudspeakerb18',
  'floorstandingloudspeakerb28',
  'floorstandingloudspeakerb38',
  'floorstandingloudspeakerba31',
  'floorstandingloudspeakerba71',
  'floorstandingloudspeakerb100',
  'floorstandingloudspeakerbc150',
  'floorstandingloudspeakerbc350',
]
